declare module '*.st.css' {
  const stylesheet: import('@stylable/runtime').RuntimeStylesheet;
  export = stylesheet;
}

declare module 'react-codemirror-runmode';
declare module '@wix/wix-storybook-utils/*';
